module.exports = __webpack_public_path__ + "static/media/(H)-Artesanato-04.fb33d924.jpg";